export function scrollPageToTop(anchorEl) {
    const reset = () => {
        window.scrollTo(0, 0);
        if (document.documentElement) {
            document.documentElement.scrollTop = 0;
            document.documentElement.scrollLeft = 0;
        }
        if (document.body) {
            document.body.scrollTop = 0;
            document.body.scrollLeft = 0;
        }

        [
            '#root',
            '.page-wrapper',
            '.page-body-wrapper',
            '.page-body',
            '.page-sidebar',
            '.sidebar',
        ].forEach((selector) => {
            const el = document.querySelector(selector);
            if (el) {
                el.scrollTop = 0;
                el.scrollLeft = 0;
            }
        });

        if (anchorEl && typeof anchorEl.scrollIntoView === 'function') {
            anchorEl.scrollIntoView({ block: 'start', inline: 'nearest' });
        }
    };

    reset();
    if (typeof window !== 'undefined' && window.requestAnimationFrame) {
        window.requestAnimationFrame(reset);
    }
    setTimeout(reset, 0);
    setTimeout(reset, 50);
    setTimeout(reset, 150);
}
